export const MAX_DYNAMIC_TABS = 10;

export const MAX_TAB_LIMIT_MESSAGE =
  "Max tab limit reached. Close unused tabs before proceeding.";

export function isDynamicTabLimitReached(sliceState) {
  return (sliceState?.dynamicTabs?.length ?? 0) >= MAX_DYNAMIC_TABS;
}

export function isActivatingExistingDynamicTab(sliceState, payload) {
  const tab = payload;
  if (!tab?.key) {
    return false;
  }

  return sliceState.dynamicTabs.some(
    (existingTab) =>
      existingTab.key === tab.key && existingTab.contentType === tab.contentType
  );
}

export function pushDynamicTab(state, tab, staticTabCount) {
  if (isDynamicTabLimitReached(state)) {
    return false;
  }

  const normalizedTab = {
    ...tab,
    createdAt: tab?.createdAt ?? Date.now(),
  };

  state.dynamicTabs.push(normalizedTab);
  state.activeTab = staticTabCount + state.dynamicTabs.length - 1;
  return true;
}
